import { Component, Input, OnInit } from '@angular/core';
import { DeviceBaseFragment } from '@designage/gql';

@Component({
  selector: 'app-screenshot',
  templateUrl: './screenshot.component.html',
  styleUrls: ['./screenshot.component.scss'],
})
export class ScreenshotComponent implements OnInit {
  @Input()
  device!: DeviceBaseFragment;

  constructor() {}

  ngOnInit(): void {}
}
